import Rest from '../Rest'

export default class GroupNewsService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/group_news'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  cloneByGroup(id: Number, data: any = null) {
    return this.post(`/${id}/newsletters/clone_by_group`, data)
  }
}
